<template>
    <div class="full-width full-screen-part" v-loading="loading">
        <div class="header-part">
            <productTypeList :list="typeList" :selectedCode="selectedCode" @clickTypeBox="clickTypeCallback" />
        </div>

        <div class="page-content-part">
            <el-scrollbar>
                <quotationProductList :list="typeItemList" @selectProduct="selectProductCallback" />

                <el-empty v-show="typeItemList == null || typeItemList.length == 0" :description="i18n.tkey('lang_business_currently_no_product_message')">

                </el-empty>
            </el-scrollbar>
        </div>

    </div>
</template>

<script setup>
    import quotationProductList from "@/components/shopopee/quotation/quotationProductList"
    import productTypeList from "@/components/shopopee/quotation/productTypeList"
    import {inject, onBeforeMount, provide, ref} from "vue";
    import myUtil from "@/util/util";
    import materialApi from "@/request/materialApi";
    import companyApi from "@/request/companyApi";
    import eshopopeeApi from "@/request/eshopopeeApi";

    const props = defineProps(["companyInfo"])

    const i18n = inject("i18n")
    const loading = ref(false)

    const typeList = ref([])
    const itemMap = ref({})
    const typeItemList = ref([])
    const allItemList = ref([])
    const allItemMap = {}
    const selectedCode = ref(null)
    const companyInfo = {}
    const selectProductMap = {}

    function getProductList(){
        loading.value = true

        const request = materialApi.getCompanyMaterialAndType
        const params = request.getParams()

        params.companycode = props.companyInfo.companycode

        request.send(params, (res) => {
            loading.value = false

            if (res.code == 200){
                const obj = res.detail
                const materialTypeMap = {}

                typeList.value = obj.whatsshopsbcataList

                obj.materialList.forEach((v, i) => {
                    if (null == materialTypeMap[v.bcatacode]){
                        materialTypeMap[v.bcatacode] = []
                    }

                    materialTypeMap[v.bcatacode].push(v)

                    allItemMap[v.productid] = v
                    v.ClientProSerQtyList = []
                })

                itemMap.value = materialTypeMap
                allItemList.value = obj.materialList

                getClientProSerQty()

            }else{
                myUtil.alertError(res.msg)
            }
        })

    }

    function clickTypeCallback(obj){
        if (obj.bcatacode == selectedCode.value){
            selectedCode.value = null
        }else{
            selectedCode.value = obj.bcatacode
        }

        changeItemType()
    }

    function changeItemType(){
        if (null == selectedCode.value){
            typeItemList.value = allItemList.value
        }else{
            typeItemList.value = itemMap.value[selectedCode.value]
        }
    }

    function getClientProSerQty(){
        let productidList = ""

        allItemList.value.forEach((v, i) => {
            productidList += `'${v.productid}',`
        })

        if (productidList.length > 0){
            productidList = productidList.substring(0, productidList.length - 1)
        }

        const request = eshopopeeApi.getClientProSerQty
        const params = request.getParams()

        params.companycode = companyInfo.acccompanycode
        params.idList = productidList

        request.send(params, (res) => {
            if (res.code == 200){
                const list = res.detail

                list.forEach((v, i) => {
                    allItemMap[v.ProductID].ClientProSerQtyList.push(v)
                })

                typeItemList.value = allItemList.value

            }
        })

    }

    function selectProductCallback(flag, obj){
        if (flag){
            selectProductMap[obj.mid] = obj
        }else{
            delete selectProductMap[obj.mid]
        }
    }

    function getSelectProductMap(){
        return selectProductMap
    }

    onBeforeMount(() => {
        Object.assign(companyInfo, props.companyInfo)

        getProductList()
    })

    provide('quotationProductExhibition', {
        getSelectProductMap
    })

    defineExpose({
        getSelectProductMap
    })

</script>

<style scoped>
    .full-width {
        width: 100%;
        position: relative;
    }

    .full-screen-part {
        width: 100%;
        height: 100%;
    }

    .header-part {
        width: 100%;
        height: 50px;
    }

    .page-content-part {
        width: 100%;
        height: calc(100% - 55px);
        overflow-x: hidden;
        overflow-y: auto;
    }
</style>